/**
 * Created by ianva on 16/7/4.
 */

var _ = require("underscore");

function object2class(obj) {
    var array = [];
    _.each(obj, function (val, key) {
        if (val === true) {
            array.push(key);
        } else if (_.isString(val) && val !== '') {
            array.push(val);
        }
    });
    return array.join(" ");
}


/**
 * 生成一个 uid
 * @param {String} 指定 uid 所属命名空间名
 */
var createUID = function (name) {
    return _.uniqueId( name + '_') + '_' + new Date().getTime();
};

module.exports = {

    object2class,
    createUID
    
};



/** WEBPACK FOOTER **
 ** ./script/cutil/gin-notify/utils.js
 **/